import React, { Component } from 'react';
import { Input, Icon,message } from 'antd';
import ContentList from './ContentList';

const IconStyle = {
    marginLeft: 10,
    verticalAlign: 'middle',
    fontSize:"20px",
    marginBottom:"4px"
};

class MultiInput extends Component {

    state = {
        value: undefined,
        jugeId:undefined,
        haveNoJDE:false
    }

    handleChange = (e) => {
        this.setState({ value: e.target.value });
    }

    setValue =(v)=>{
        this.setState({ value: v });
    }

    handleClick = () => {
        const { list } = this.props;
        const { value } = this.state;
        const newList = [...(list || [])];
        let duplicate = list.indexOf(value) > -1;
        if(duplicate){
           message.error("JDE项目号无法重复");
        }else{
            newList.push(value);
            this.props.onChange(newList);
            this.setState({ value: undefined,haveNoJDE:false },
                () => {
                    this.jugeTolast("mulInput");
                 }
                );
        }
    }

    handleRemove = (index) => {
        const { list } = this.props;
        list.splice(index, 1);
        this.props.onChange(list);
    }

    changeItem = (e,index) => {
        const { list } = this.props;
        const inputValue = e.target.value;
        let duplicate = list.indexOf(inputValue) > -1;
        if(duplicate){
            message.error("JDE项目号无法重复");
         }else{
        list[index]=inputValue;
        this.props.onChange(list);
        const{jugeId}=this.state;
        if(jugeId==`${index}choose`){
            this.contentListRef.setErrRemark(undefined);
        }
        }
    }

    jugeTolast=(id)=>{
        this.setState({
            jugeId:id
        });
        this.contentListRef.jugeTolast(id);
    }
    
    changeHaveNoJDE=(boolean)=>{
        this.setState({
            haveNoJDE:boolean
        });
    }
    
    setRemindList=(notExistJdeCodes,duplicateJdeCodes)=>{
        this.contentListRef.setRemindList(notExistJdeCodes,duplicateJdeCodes) 
    }

    render() {
        const { list=[] } = this.props;
        const { value,haveNoJDE } = this.state;
        return (
            <div>
                {list.length>0&&
                <ContentList
                    className="templateList"
                    data={list}
                    circle={true}
                    onRemove={(index) => this.handleRemove(index)}
                    render={item => item}
                    onChange={this.changeItem}
                    ref={el => this.contentListRef = el}
                />
                }
                {list.length<=19&&
                    <div style={{ marginTop: 10,marginBottom:10 }}>
                        <Input maxLength="255" value={value} placeholder={"请输入"} style={{ width: 240 }} onChange={this.handleChange} />
                        {
                            !value ?
                                <Icon type="plus-circle-o" style={{ ...IconStyle,color:"#c2c7cc",cursor: 'no-drop' }} />
                            :
                                <Icon type="plus-circle-o" style={{ ...IconStyle, color: '#5b96c9', cursor: 'pointer' }} onClick={this.handleClick} />
                        }
                         {haveNoJDE&&<span className="errRemark" >请填写JDE项目号</span>}
                    </div>
                }
            </div>
        );
    }
}

export default MultiInput;


// WEBPACK FOOTER //
// ./src/components/layout/MultiInput.js